import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../../../../api/AuthService";
import { useAlert } from "../../../../../context/AlertContext";
import EditQuote from "../../../../../entities/DashboardPage/AccountingModule/Quotes/EditQuotes";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";

const QuotesEdit = () => {
  const [customerList, setCustomerList] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [attachmentUrl, setAttachmentUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [quoteData, setQuoteData] = useState(null);
  const navigate = useNavigate();
  const { state } = useLocation();
  const { item } = state || {};
  const { showAlert } = useAlert();

  useEffect(() => {
    getItem();
    getQuote(item?._id);
    getCustomerList();
  }, []);

  const getQuote = async (quotedId) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getQuote(quotedId);
      if (result?.data) {
        setQuoteData(result.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const updateQuote = async (quoteData) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.updateQuote(item?._id, quoteData);
      if (result?.success) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert("Quote updated successfully", "success");
        navigate("/dashboard/quotes");
      } else {
        showAlert(result.message, "error");
        setLoading(false);
        LoaderHelper.loaderStatus(false);
      }
    } catch (apiError) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
      return;
    }
  };

  const getItem = async (text) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getItemsList(text);
      if (result?.success) {
        setItemList(result?.data?.items);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getCustomerList = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getCustomer(text, sort, page);
      if (result?.success) {
        setCustomerList(result?.data?.customers);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleFileUpload = async (file) => {
    if (!file) return;

    LoaderHelper.loaderStatus(true);
    try {
      const formData = new FormData();
      formData.append("file", file);

      const result = await AuthService.uploadFile(formData);
      if (result?.success) {
        setAttachmentUrl(result.data.url);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <EditQuote
      customerList={customerList}
      itemList={itemList}
      handleItem={getItem}
      handleFileUpload={handleFileUpload}
      attachmentUrl={attachmentUrl}
      updateQuote={updateQuote}
      loading={loading}
      quoteData={quoteData}
    />
  );
};

export default QuotesEdit;
